import styled from 'styled-components'
//////////////////////////////////////////////////////////////////
//////////////****AUTHOR : AGHILES AZZOUG -  *////////////////////
//////////////*****JUIN - AOUT 2021 */////////////////////////////
/////////////Développement et design /////////////////////////////
/////////Propriété privé de Layer Data - Rachid Tighremt//////////
////////Tous droits reservés ... interdit tout plagiat ///////////
////////    interdit tout usage sans autorisation     ////////////
///////---------------------------------------------//////////////
//////////////////////////////////////////////////////////////////
export const RessourcesContainer = styled.section`
// height: 65rem;
height: 100vh;
display: flex;
flex-direction: column;
justify-content: center;
align-items: center;
background: #1fa8ff;

@media only screen and (max-width:1172px) {
  height: 70rem;
}

@media only screen and (max-width:1000px) {
  height: 80rem;

}
@media only screen and (max-width:768px) {
  height: 140rem;

}

`;

export const RessourcesWrapper = styled.div`
max-width: 1300px;
margin: 0 auto;display: grid;
grid-template-columns: 1fr 1fr 1fr;
align-items: center;
justify-content: center;
grid-gap: 2.5rem;
padding: 0 50px;

@media only screen and (max-width:1000px) {
  grid-template-columns: 1fr 1fr 1fr;
}

@media only screen and (max-width:768px) {
  grid-template-columns: 1fr;
  padding: 0 20px;
}
`;



export const RessourcesH1 = styled.h1`
font-size: 4rem;
color: #fff;
margin-bottom: 6.4rem;

@media only screen and (max-width: 480px){
  font-size: 3.2rem
}
`;

export const RessourcesCard = styled.div`
background-color:#fff;
display: flex;
flex-direction: column;
text-align: center;
border-radius: 10px;
max-height: 38rem;
padding: 3.8rem;
box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
transition: all .5s ease;
line-height: 1.4;

&:hover{
  transform: scale(1.1);
  cursor: pointer;

  @media only screen and (max-width:768px){
    transform: scale(1.02);
  }
}

/* @media only screen and (max-width:1900px){
    max-height: 50rem;
  } */
`;
export const RessourcesCard1 = styled.div`
background-color:#fff;
display: flex;
flex-direction: column;
text-align: center;
border-radius: 10px;
max-height: 31.8rem;
padding: 3.8rem;
box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
transition: all .5s ease;
line-height: 1.4;

&:hover{
  transform: scale(1.1);
  cursor: pointer;

  @media only screen and (max-width:768px){
    transform: scale(1.02);
  }
}

/* @media only screen and (max-width:1900px){
    max-height: 50rem;
  } */
`;

export const SocialIconLink = styled.a`
font-size: 2.4rem;
color: #1fa8ff;
transition: all .3s ease;

&:hover {
  color: #2962f2;
  transform: scale(1.05) translateX(.5rem) translateY(.5rem);
}
`;

export const RessourcesIcon = styled.img`
height: 22rem;
width: 16rem;
margin-bottom: 1rem;
margin: 0 auto;
`;
export const RessourcesH2 = styled.h2`
padding-top: 1rem;
margin-bottom: 0.6rem;
font-size: 1.2rem;
font-weight: bold;

`;
export const RessourcesH3 = styled.h2`
padding-top: 1rem;
font-size: 1.2rem;
font-weight: bold;
`;


export const RessourcesP = styled.p`
text-align: center;
font-size: 1.1rem;
margin-bottom: 0px;
padding-bottom:0px;
`;
export const RessourcesPl = styled.p`
text-align: center;
margin-top:0px;
padding-top:0px;
font-size: 1.1rem;
padding-bottom:0px;
margin-bottom: 0px;
`;
